<template>
    <div style="padding-bottom: 100px; background: #f7f6fb;">
        <!-- 搜索和功能区域 -->
        <div style="background: #fff; padding: 10px 16px;">
            <div style="display: flex; align-items: center; margin-bottom: 12px;">
                <!-- 返回按钮 -->
                <div style="margin-right: 12px;" @click="$router.back()">
                    <img src="/static/order/back.png" alt="返回" style="width: 24px; height: 24px;" />
                </div>

                <!-- 搜索框 -->
                <div
                    style="flex: 1; background: #f5f5f5; border-radius: 20px; padding: 8px 16px; font-size: 14px; color: #999;">
                    搜索我的订单
                </div>

                <!-- 功能按钮 -->
                <div style="margin-left: 12px; display: flex; align-items: center;">
                    <span style="font-size: 14px; color: #333; margin-right: 16px;">开发票</span>
                </div>
            </div>

            <!-- 订单状态标签 -->
            <div style="display: flex; justify-content: space-between;">
                <div v-for="status in orderStatuses" :key="status.value" @click="switchStatus(status.value)" :style="{
                    'font-size': '15px',
                    'padding': '8px 0',
                    'color': activeStatus === status.value ? '#07c160' : '#333',
                    'font-weight': activeStatus === status.value ? '600' : '400',
                    'border-bottom': activeStatus === status.value ? '2px solid #07c160' : 'none',
                    'flex': '1',
                    'text-align': 'center'
                }">
                    {{ status.label }}
                </div>
            </div>
        </div>

        <!-- 根据订单数量显示不同内容 -->
        <div v-if="orderListWithData.length === 0" style="padding-top: 60px;">
            <!-- 购物车为空状态 -->
            <div style="text-align: center; padding: 0 16px;">
                <img :src="emptyCartImage" alt="购物车为空" style="width: 120px; height: 120px; margin-bottom: 24px;" />
                <div style="font-size: 16px; color: #999; margin-bottom: 20px;">
                    您的购物车还空着呐~快去逛逛吧
                </div>
                <div @click="goShopping" style="
                        display: inline-block;
                        background: #07c160;
                        color: white;
                        font-size: 15px;
                        padding: 10px 40px;
                        border-radius: 20px;
                        font-weight: 500;
                    ">
                    去逛逛
                </div>
            </div>

            <!-- 你可能想买 -->
            <div style="margin-top: 40px; padding: 0 16px;">
                <div style="font-size: 16px; font-weight: 600; color: #333; text-align: center; margin-bottom: 16px;">
                    你可能想买
                </div>

                <div class="goods-grid">
                    <div v-for="item in recommendedProducts" :key="item.id" class="product-card"
                        @click="goToDetail(item)">
                        <img :src="item.image" class="product-img" alt="" />
                        <div class="product-info">
                            <div class="product-title">{{ item.title }}</div>
                            <div class="product-desc">{{ item.desc }}</div>
                            <div class="product-tags">
                                <span class="new-user-tag">新人首单价</span>
                                <span class="lowest-price-tag">近30天最低价</span>
                            </div>
                            <div class="price-row">
                                <div style="display: flex; align-items: baseline;">
                                    <span class="current-price">¥{{ item.price }}</span>
                                    <span class="old-price" v-if="item.originalPrice">¥{{ item.originalPrice }}</span>
                                </div>
                                <div class="add" @click.stop="addToCart(item)">+</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 有订单时的列表 -->
        <div v-else style="background: #f7f6fb; min-height: 100vh;">
            <div v-for="order in orderListWithData" :key="order.id"
                style="background: white; margin-top: 10px; padding: 16px;">
                <!-- 订单项 - 使用两列布局 -->
                <div style="display: flex; align-items: flex-start;">
                    <!-- 第一列：商品图片 -->
                    <div style="flex-shrink: 0; margin-right: 12px;">
                        <img :src="order.image" alt="商品图片"
                            style="width: 80px; height: 80px; border-radius: 8px; object-fit: cover;" />
                    </div>

                    <!-- 第二列：商品信息 -->
                    <div style="flex: 1;">
                        <!-- 第一行：商品名称 + 交易状态 -->
                        <div
                            style="display: flex; justify-content: space-between; align-items: flex-start; margin-bottom: 8px;">
                            <div
                                style="font-size: 14px; font-weight: 700; color: #333; line-height: 1.2; flex: 1;text-align: left;">
                                {{ order.title }}
                            </div>
                            <div
                                style="font-size: 14px; color: #FF0000; font-weight: 500; margin-left: 8px; flex-shrink: 0;">
                                {{ order.status }}
                            </div>
                        </div>

                        <!-- 第二行：规格 + 实付款/合计 -->
                        <div
                            style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px;">
                            <div style="font-size: 11px;color: #949494;">
                                规格：{{ order.spec }}
                            </div>
                            <div style="font-size: 16px; color: #000000; font-weight: 600; flex-shrink: 0;">
                                {{ order.status === '交易成功' ? '实付款' : '合计' }}{{ order.amount }}
                            </div>
                        </div>

                        <!-- 第三行：数量 + 功能按钮 -->
                        <div style="display: flex; justify-content: space-between; align-items: center;">
                            <div style="font-size: 11px; color: #949494;">
                                数量：{{ order.quantity }}
                            </div>
                            <div style="display: flex; gap: 8px; flex-shrink: 0;">
                                <!-- 根据订单状态显示不同按钮 -->
                                <div v-if="order.status === '交易成功' || order.status === '交易关闭'" @click="addToCart(order)"
                                    style="
                                        color: #000000;
                                        font-size: 10px;
                                        padding: 0 6px;
                                        white-space: nowrap;
                                        background: #EBEBEB;
                                        height: 18px;
                                        line-height: 18px;
                                    ">
                                    加入购物车
                                </div>
                                <div v-if="order.status === '交易成功' || order.status === '交易关闭'" @click="buyAgain(order)"
                                    style="
                                        background: #FFE4E4;
                                        color: #FF0000;
                                        font-size: 10px;
                                        padding: 0 6px;
                                        white-space: nowrap;
                                        height: 18px;
                                        line-height: 18px;
                                    ">
                                    再买一单
                                </div>

                                <!-- 待支付状态 -->
                                <div v-if="order.status === '待支付'" @click="cancelOrder(order)" style="
                                        color: #000000;
                                        font-size: 10px;
                                        padding: 0 6px;
                                        white-space: nowrap;
                                        background: #EBEBEB;
                                        height: 18px;
                                        line-height: 18px;
                                    ">
                                    取消订单
                                </div>
                                <div v-if="order.status === '待支付'" @click="continuePay(order)" style="
                                        background: #FFE4E4;
                                        color: #FF0000;
                                        font-size: 10px;
                                        padding: 0 6px;
                                        white-space: nowrap;
                                        height: 18px;
                                        line-height: 18px;
                                    ">
                                    继续付款
                                </div>

                                <!-- 待发货状态 -->
                                <div v-if="order.status === '待发货'" @click="remindShipping(order)" style="
                                        background: #FFE4E4;
                                        color: #FF0000;
                                        font-size: 10px;
                                        padding: 0 6px;
                                        white-space: nowrap;
                                        height: 18px;
                                        line-height: 18px;
                                    ">
                                    提醒发货
                                </div>

                                <!-- 待收货状态 -->
                                <div v-if="order.status === '待收货'" @click="viewLogistics(order)" style="
                                        color: #000000;
                                        font-size: 10px;
                                        padding: 0 6px;
                                        white-space: nowrap;
                                        background: #EBEBEB;
                                        height: 18px;
                                        line-height: 18px;
                                    ">
                                    查看物流
                                </div>
                                <div v-if="order.status === '待收货'" @click="confirmReceive(order)" style="
                                        background: #FFE4E4;
                                        color: #FF0000;
                                        font-size: 10px;
                                        padding: 0 6px;
                                        white-space: nowrap;
                                        height: 18px;
                                        line-height: 18px;
                                    ">
                                    确认收货
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'OrderPage',
    data() {
        return {
            // 订单状态
            orderStatuses: [
                { value: 'all', label: '全部' },
                { value: 'pendingPay', label: '待支付' },
                { value: 'pendingShip', label: '待发货' },
                { value: 'pendingReceive', label: '待收货' }
            ],
            activeStatus: 'all',

            // 空购物车图片
            emptyCartImage: '/static/order/no-order.png',

            // 订单列表（为空数组时显示空状态）
            orderList: [],

            // 有订单时的模拟数据
            orderListWithData: [
                {
                    id: 1,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '交易成功',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                {
                    id: 2,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '交易成功',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                {
                    id: 3,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '交易关闭',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                {
                    id: 4,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '交易关闭',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                // 示例：待支付订单
                {
                    id: 5,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '待支付',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                // 示例：待发货订单
                {
                    id: 6,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '待发货',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                // 示例：待收货订单
                {
                    id: 7,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '待收货',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                }
            ],

            // 推荐商品列表
            recommendedProducts: [
                {
                    id: 1,
                    title: '荣事达电饭煲',
                    desc: '智能菜单 蒸煮双同步 预约定时 不粘内胆',
                    price: '0.01',
                    originalPrice: '15.09',
                    image: '/static/order/Rectangle 1384.png',
                    tags: ['新人首单价', '近30天最低价']
                },
                {
                    id: 2,
                    title: '荣事达电饭煲',
                    desc: '智能菜单 蒸煮双同步 预约定时 不粘内胆',
                    price: '0.01',
                    originalPrice: '15.09',
                    image: '/static/order/Rectangle 1384.png',
                    tags: ['新人首单价', '近30天最低价']
                }
            ]
        };
    },
    methods: {
        handleQueryParams() {
            const status = this.$route.query.status;
            if (status && this.orderStatuses.some(s => s.value === status)) {
                this.switchStatus(status);
            }
        },
        switchStatus(status) {
            this.activeStatus = status;
            console.log(`切换到订单状态: ${status}`);

            // 根据状态筛选订单
            if (status === 'all') {
                this.orderListWithData = this.getAllOrders();
            } else if (status === 'pendingPay') {
                this.orderListWithData = this.getPendingPayOrders();
            } else if (status === 'pendingShip') {
                this.orderListWithData = this.getPendingShipOrders();
            } else if (status === 'pendingReceive') {
                this.orderListWithData = this.getPendingReceiveOrders();
            } else if (status === 'refund') {
                // 处理退款/售后状态
                this.orderListWithData = this.getRefundOrders();
            }
        },

        getRefundOrders() {
            return [
                {
                    id: 8,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '退款中',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                {
                    id: 9,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '退款成功',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                {
                    id: 10,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '售后处理中',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                }
            ];
        },

        goShopping() {
            console.log('去逛逛');
            // 跳转到首页或商品列表页
            this.$router.push('/');
        },

        goToDetail(item) {
            console.log(`跳转到商品详情: ${item.title}`);
            // 跳转到商品详情页
            this.$router.push({
                path: '/detail',
                query: { id: item.id }
            });
        },

        addToCart(item) {
            console.log(`加入购物车: ${item.title}`);
            // 添加购物车逻辑
            this.$toast('已加入购物车');
        },

        buyAgain(order) {
            console.log(`再买一单: ${order.title}`);
            // 再次购买逻辑
            this.$toast('已加入购物车，请前往结算');
        },

        cancelOrder(order) {
            console.log(`取消订单: ${order.id}`);
            this.$confirm('确定要取消此订单吗？').then(() => {
                // 取消订单逻辑
                this.$toast('订单已取消');
            });
        },

        continuePay(order) {
            console.log(`继续付款: ${order.id}`);
            // 跳转到支付页面
            this.$router.push({ path: '/pay', query: { orderId: order.id } });
        },

        remindShipping(order) {
            console.log(`提醒发货: ${order.id}`);
            this.$toast('已提醒卖家尽快发货');
        },

        viewLogistics(order) {
            console.log(`查看物流: ${order.id}`);
            this.$router.push({ path: '/logistics', query: { orderId: order.id } });
        },

        confirmReceive(order) {
            console.log(`确认收货: ${order.id}`);
            this.$confirm('请确认已收到商品，确认后交易将完成').then(() => {
                // 确认收货逻辑
                this.$toast('已确认收货，交易完成');
            });
        },

        // 模拟数据过滤方法
        getAllOrders() {
            return [
                {
                    id: 1,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '交易成功',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                {
                    id: 2,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '交易成功',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                {
                    id: 3,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '交易关闭',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                },
                {
                    id: 4,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '交易关闭',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                }
            ];
        },

        getPendingPayOrders() {
            return [
                {
                    id: 5,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '待支付',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                }
            ];
        },

        getPendingShipOrders() {
            return [
                {
                    id: 6,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '待发货',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                }
            ];
        },

        getPendingReceiveOrders() {
            return [
                {
                    id: 7,
                    title: '荣事达电饭煲',
                    spec: '蒸煮煎炒焖炖涮',
                    quantity: 1,
                    status: '待收货',
                    amount: '￥0.01',
                    image: '/static/order/Rectangle 1384.png'
                }
            ];
        }
    },
    mounted() {
        // 初始化时显示所有订单
        this.switchStatus('all');

        // 从URL参数中获取状态并切换
        this.handleQueryParams();
    }
};
</script>

<style scoped>
/* 你可能想买 - 商品网格 */
.goods-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 12px;
}

/* 商品卡片样式 */
.product-card {
    background: #fff;
    border-radius: 8px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.2s;
}

.product-card:active {
    transform: scale(0.98);
}

.product-img {
    width: 100%;
    height: 140px;
    object-fit: cover;
    background: #f0f0f0;
}

.product-info {
    padding: 12px 10px;
}

.product-title {
    font-weight: 500;
    font-size: 14px;
    color: #333;
    line-height: 1.4;
    text-align: left;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    line-clamp: 2;
    -webkit-box-orient: vertical;
    margin-bottom: 6px;
}

.product-desc {
    margin: 4px 0;
    font-weight: 300;
    font-size: 11px;
    color: #666;
    text-align: left;
    line-height: 1.4;
}

.product-tags {
    display: flex;
    gap: 4px;
    margin: 8px 0;
}

.new-user-tag {
    font-size: 10px;
    color: #e93b3d;
    background: #ffeaea;
    padding: 2px 4px;
    border-radius: 2px;
}

.lowest-price-tag {
    font-size: 10px;
    color: #ff6b00;
    background: #fff3e8;
    padding: 2px 4px;
    border-radius: 2px;
}

/* 价格行样式 */
.price-row {
    display: flex;
    align-items: baseline;
    justify-content: space-between;
    gap: 6px;
    margin: 8px 0 4px;
    padding: 0 10px 0 5px;
}

.add {
    width: 17px;
    height: 17px;
    background: #07c160;
    border-radius: 50%;
    line-height: 17px;
    text-align: center;
    color: #fff;
    font-size: 18px;
    cursor: pointer;
    transition: background 0.2s;
}

.add:active {
    background: #05b52d;
    transform: scale(0.94);
}

.current-price {
    font-size: 18px;
    font-weight: 800;
    color: #ff3b2f;
}

.old-price {
    font-size: 11px;
    color: #aaa;
    text-decoration: line-through;
    margin-left: 4px;
}

/* 小屏幕适配 */
@media (max-width: 400px) {
    .product-img {
        height: 120px;
    }

    .goods-grid {
        gap: 10px;
    }
}
</style>


// WEBPACK FOOTER //
// src/views/Order.vue